<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="container">
            <div class="grid grid-cols-3 md:grid-cols-6">
                <div class="text-xl font-bold col-span-3 md:col-span-2 mt-3">
                    {{ $t('sale.todayTradeAmount') }}
                </div>
                <div v-if="purchaseCurrency !== null" class="col-span-2 md:col-span-1 text-main font-bold text-xl ml-2 mt-3">
                    {{
                        getTotalPurchaseAmount()
                    }}
                </div>
                <div class="col-span-1 mt-3">
                    <b-form-select
                        class="border-0 mt-n1 focus:ring-0 w-20"
                        v-model="selectedCurrencyShortName">
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>
            </div>

            <SearchCollapse :is-bg-white="true" :do-action="showCheckbox" :show-collapse="isCollapsed">
            </SearchCollapse>
        </div>

        <b-modal id="pay-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="payDebts">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$bvModal.hide('pay-modal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>
        <b-modal id="more-pay-modal" size="lg" :title="$t('payDebt')" hide-footer>
            <!-- Modal body -->
            <div class="modal-body row">
                <div class="col-12 col-lg-6">
                    <div>
                        {{ $t('selected') }}: {{ payDebtsSales.length }}
                    </div>
                    <div>
                        {{ $t('customer.title') }}:
                        <span v-for="(customer, index) of customers" :key="index" style="color: #46BDA1">
                            <span v-if="index !== 0">, </span>{{ customer }}</span>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div style="color: #24AA29" class="row">
                        <div class="col-6">{{ $t('statistics.categories.totalSale') }}:</div>
                        <div class="col-6">{{ showCurrencyById(getUserCompany.baseCurrency.id, salesTotalPrice) }}</div>
                    </div>
                    <div style="color: #ff0000" class="row">
                        <div class="col-6">{{ $t('debtor.indebtedness') }}:</div>
                        <div class="col-6">{{ showCurrencyById(getUserCompany.baseCurrency.id, salesTotalDebts) }}</div>
                    </div>
                </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <b-button
                    variant="danger"
                    size="sm"
                    style="background-color: red; color: #fff"
                    data-dismiss="modal"
                    @click="$bvModal.hide('more-pay-modal')"
                >
                    {{ $t('sale.transaction.cancel') }}
                </b-button>
                <b-button
                    variant="success"
                    size="sm"
                    data-dismiss="modal"
                    @click="payMoreDebts"
                >
                    {{ $t('pay') }}
                </b-button>
            </div>
        </b-modal>


        <table class="w-full mt-3">
            <thead>
            <tr class="bg-lightGray h-11">
                <th v-if="isCollapsed"></th>
                <th class="d-none d-lg-table-cell pl-3">{{ $t('printView.receipt') }}</th>
                <th class="d-none d-lg-table-cell">{{ $t('employee.cashier') }}</th>
                <th>{{ $t('totalPrice') }}</th>
                <th>{{ $t('customer.title') }}</th>
                <th class="d-none d-lg-table-cell">{{ $t('incomeAndOutcome.Status') }}</th>
                <th class="d-none d-sm-table-cell">{{ $t('date') }}</th>
                <th>{{ $t('actions') }}</th>
            </tr>
            </thead>
            <tbody
                v-for="sale of sales"
                :key="sale.id"
            >
            <tr class="h-11 border-bottom">
                <td v-if="isCollapsed">
                    <span v-if="sale.isSelected">
                        <b-form-checkbox
                            v-if="isDebt(sale)"
                            class="d-inline ml-3"
                            size="lg"
                            :value="sale"
                            v-model="payDebtsSales"
                        ></b-form-checkbox>
                        <b-form-checkbox
                            v-else
                            class="d-inline ml-3"
                            size="lg"
                            :value="sale.id"
                            v-model="toDeleteSales"
                        ></b-form-checkbox>
                    </span>
                </td>

                <td class="d-none d-lg-table-cell pl-3"> {{ sale.id }}</td>
                <td class="d-none d-lg-table-cell">
                    <router-link :to="$i18nHelper.getUrl('employees/' + sale.employee.id)" class="font-bold">
                        {{ getEmployeeName(sale) }}
                    </router-link>
                </td>
                <td>{{ totalPrice(sale) }}</td>
                <td>
                    <router-link :to="$i18nHelper.getUrl('customers/' + sale.customer.id)" class="font-bold">
                        {{ getCustomerName(sale) }}
                    </router-link>
                </td>
                <td class="d-none d-lg-table-cell">{{ hasPayedText(sale) }}</td>
                <td class="d-none d-sm-table-cell">{{ createdAt(sale) }}</td>
                <td>
                    <img v-if="hasNotPayedCanceled" @click="showSaleAll(sale.id); oneSale = sale" src="/images/read-more.png" alt="" class="h-7 cursor-pointer pr-3">
                    <img v-if="!sale.isCanceled" @click="setId(sale)" src="/images/edit.png" alt="" class="h-6 cursor-pointer">
                </td>
            </tr>
            <tr v-if="sale.id === saleId && saleProductsAndServices.length > 0">
                <td></td>
                <td colspan="6">
                    <Row
                        type="form-row"
                        class="col-sm-10 m-0 border border-gray-300 rounded-sm pt-2 my-2 justify-content-end"
                    >
                        <div class="col-12">
                            <div class="float-left">{{ $t('detailed') }}</div>
                            <div class="float-right">
                                {{ $t('printView.receipt') }}{{ sale.id }}
                            </div>
                        </div>
                        <table class="table pr-10 pl-10">
                            <thead>
                            <tr>
                                <th>{{ $t('product.title') }}</th>
                                <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                                <th>{{ $t('amount') }}</th>
                                <th>{{ $t('sale.sum') }}</th>
                            </tr>
                            </thead>
                            <tbody
                                v-for="(saleItem, index) in saleProductsAndServices"
                                :key="index"
                            >
                            <tr
                                :style="saleItem.updatedAt !== null ? 'background-color: #EE9BF5' : 'background-color: #fff'"
                                v-if="saleItem['@type'] === 'SaleProduct'"
                            >
                                <td> {{ saleItem.product.name }}</td>
                                <td class="d-none d-sm-table-cell">
                                    {{ showPrice(saleItem) }}
                                </td>
                                <td>
                                    {{
                                        parseFloat(saleItem.amount) + ' ' + showUnitOfMeasure(saleItem.product.unitOfMeasure)
                                    }}
                                </td>
                                <td>{{ showCurrencyById(sale.currency.id, saleItem.price) }}</td>
                            </tr>
                            <tr
                                :style="saleItem.updatedAt !== null ? 'background-color: #EE9BF5' : 'background-color: #fff'"
                                v-else
                            >
                                <td> {{ saleItem.service.name }}
                                    <span style="font-size: 11px">{{' ' + '(' + $t('service.title') + ')'}}</span>
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ parseFloat(saleItem.price) / parseFloat(saleItem.amount) }}
                                </td>
                                <td>
                                    {{
                                        parseInt(saleItem.amount)
                                    }}
                                </td>
                                <td>{{ showCurrencyById(sale.currency.id, saleItem.price) }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="col-12 d-sm-inline">
                            <Row class="mx-md-5 my-md-2">
                                <div class="col-12">
                                    <span class="float-left ml-n3">{{ $t('payedAmount') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(
                                                getSale.currency.id,
                                                parseFloat(sale.totalPurchaseAmount > 0 ? sale.totalPurchaseAmount : sale.totalPrice))
                                        }}</span>
                                </div>
                                <div v-if="sale.bonusSumAmount > 0" class="col-12">
                                    <span class="float-left ml-n3">{{ $t('sale.discount.title') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, parseFloat(sale.bonusSumAmount ? sale.bonusSumAmount : '0'))
                                        }}</span>
                                </div>
                                <div v-if="sale.discountPercent > 0" class="col-12">
                                    <span class="float-left ml-n3">{{ $t('sale.discount.title') }}</span>
                                    <span
                                        class="float-right">{{
                                            sale.discountPercent + '% = ' + showCurrencyById(sale.currency.id, parseFloat(sale.bonusPercentAmount))
                                        }}</span>
                                </div>
                                <div class="col-12">
                                    <span class="float-left">{{ $t('payed') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, sale.payedAmount)
                                        }}</span>
                                </div>
                                <div class="col-12" v-if="sale.totalPrice-sale.payedAmount > 0">
                                    <span class="float-left">{{ $t('debt') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, sale.totalPrice - sale.payedAmount)
                                        }}</span>
                                </div>
                                <div class="col-12" v-if="!sale.isCanceled && sale.totalPrice-sale.payedAmount > 0">
                                    <div class="d-flex">
                                        <span class="flex-fill">{{ $t('payDebt') }}</span>
                                        <div class="col-6 d-flex form-control py-1">
                                            <input
                                                class="col-12 col-sm-7 col-lg-8"
                                                style="border: none; outline: none;"
                                                v-model="payDebt"
                                                type="number"
                                                min="0"
                                                @input="changeInput"
                                            />
                                            <ButtonTag
                                                class="d-none  col-sm-5 col-lg-4 pb-4 pt-0 mb-1 d-sm-flex"
                                                :is-w100="true"
                                                :type="'button'"
                                                :variant="'success'"
                                                :size="'md'"
                                                :is-disabled="isMore"
                                                :do-action="clickButton"
                                            >
                                                {{ $t('filter.all') }}
                                            </ButtonTag>
                                        </div>
                                        <button
                                            type="submit"
                                            class="form-control btn col-3 ml-1 text-white"
                                            style="background-color: #17A2B8"
                                            :disabled="!isMore"
                                            v-on:click.prevent="$bvModal.show('pay-modal')"
                                        >
                                                    <span v-show="isLoading" class="spinner-border spinner-border-sm"
                                                          role="status"
                                                          aria-hidden="true"></span>
                                            {{ $t('pay') }}
                                        </button>
                                    </div>
                                </div>
                            </Row>
                        </div>
                        <div class="mb-2 col-12 d-block">
                            <TextTag class="text-danger" v-if="sale.isCanceled">{{
                                    $t('sale.saction.canceled')
                                }}
                            </TextTag>
                            <ButtonTag
                                class="col-4 col-sm-4 mt-3 mt-sm-0"
                                :is-w100="false"
                                :type="'button'"
                                :variant="'danger'"
                                :size="'md'"
                                :do-action="canceledSale"
                                v-else
                            >
                                {{ $t('sale.transaction.cancel') }}
                            </ButtonTag>
                            <div class="col-7 col-sm-8 float-right mt-3 mt-sm-0">
                                <IconButton
                                    class="float-right"
                                    title="printView.printA4"
                                    icon="print"
                                    size="md"
                                    :do-action="printA4"
                                />
                                <IconButton
                                    class="float-right"
                                    title="printView.printCheck"
                                    icon="receipt"
                                    size="md"
                                    :do-action="printCheck"
                                />
                            </div>
                        </div>
                    </Row>
                </td>
            </tr>
            </tbody>
        </table>


        <div>
            <b-button
                class="d-flex float-right mx-2 pl-1"
                variant="danger"
                size="sm"
                v-if="payDebtsSales.length > 0"
                style="background-color: #24AA29; color: #fff"
                @click="showModalPayDebts"
            >
                {{ $t('payDebt') }}
            </b-button>
            <b-button
                class="d-flex float-right mx-2"
                variant="danger"
                size="sm"
                v-if="toDeleteSales.length > 0"
                style="background-color: red; color: #fff"
                @click="showModal"
            >
                {{ $t('delete') }}
            </b-button>
        </div>
        <RowColumn class="ml-3 mt-3">
            <Pagination
                :search="search"
                base-url="services/transactions"
                :total-items="getSaleServicesTotalCount"
                method-name="fetchSaleServicesTransaction"/>
        </RowColumn>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">{{ $t('warning') }}!</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        {{ $t('sale.editSaleWarning') }}
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn danger" data-dismiss="modal" @click="cancel()">
                            {{ $t('yes') }}
                        </button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="setId(null)">
                            {{ $t('no') }}
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <b-modal id="delete-sale-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('sale.deleteSaleWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn danger" data-dismiss="modal" @click="deleteSales">
                    {{ $t('yes') }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="cancelDelete">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

    </Row>
</template>

<script>
import RowColumn from "../../components/RowColumn";
import Pagination from "../../components/html/Pagination";
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormatting from "../../mixin/dateFormattingMixin";
import IconButton from "../../components/IconButton";
import SearchCollapse from "../../components/SearchCollapse";
import accessMixin from "@/mixin/accessMixin";
import TextTag from "@/components/html/TextTag";
import ButtonTag from "@/components/html/ButtonTag";
import Row from "@/components/html/Row";
import currencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "List",
    components: {
        Row,
        ButtonTag,
        TextTag,
        IconButton,
        Pagination,
        RowColumn,
        SearchCollapse
    },
    mixins: [currencyFormatMixin, currencyRateMixin, dateFormatting, accessMixin],
    data() {
        return {
            saleProductsAndServices: [],
            purchaseCurrency: null,
            selectedCurrencyShortName: 'UZS',
            sales: [],
            saleId: 0,
            customers: [],
            salesTotalPrice: 0.0,
            salesTotalDebts: 0.0,
            isCollapsed: false,
            item: {id: null, isCanceled: false},
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'service.title', url: 'services'},
                {name: 'transactions'},
            ],
            search: {
                personGivenName: '',
                personFamilyName: '',
                personAdditionalName: '',
                companyName: '',
                isPayed: null,
                after: '',
                before: '',
                sumMin: '',
                sumMax: '',
                page: 1
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            isShowCheckbox: false,
            toDeleteSales: [],
            selectedSales: [],
            payDebtsSales: [],
            isCheckedAll: false,
            currentDate: '',
            baseCurrency: '',
            payDebt: null,
            totalDebt: 0,
            sumDebt: 0,
            isMore: false,
            isLoading: false,
            oneSale: {},
            prevRoute: null,
        }
    },
    computed: {
        ...mapGetters([
            'getTodaySaleServiceTotalAmount',
            'getSaleServicesTotalCount',
            'getAllSales',
            'getSaleServices',
            'getSale',
            'getUserRoles',
            'getUserCompany',
            'getNewSaleId',
            'getCurrency'
        ]),
    },
    methods: {
        ...mapActions([
            'searchSales',
            'fetchAllSales',
            'pushSaleCancel',
            'deleteSale',
            'fetchSales',
            'fetchSale',
            'fetchUser',
            'fetchUpdateSalePayment',
            'pushMakePayed',
            'fetchTodaySaleServiceTotalAmount',
            'fetchSaleServicesTransaction',
            'setBreadcrumbItems'
        ]),
        getTotalPurchaseAmount() {
            if (this.purchaseCurrency === null) {
                this.purchaseCurrency = this.getCurrency(this.getTodaySaleServiceTotalAmount.currency.id)
            }

            let totalPrice = this.calculateAmountByBaseCurrency(
                this.getTodaySaleServiceTotalAmount.amount,
                this.purchaseCurrency.shortName,
                this.selectedCurrencyShortName
            )

            return this.showCurrencyWithoutSymbol(
                this.getCurrencyByShortName(this.selectedCurrencyShortName),
                totalPrice
            )
        },
        calculateReversePercentAmount(amount, percent) {
            if (percent === null) {
                percent = 0
            }

            return amount * 100 / (100 - percent)
        },
        showPrice(saleProduct) {
            if(saleProduct.price === "0.0000") {
                return 0
            }

            let isBonus = false
            let isPercent = false
            let percent = 0

            // let data = this.oneSale ? this.oneSale : this.getSale
            let data =  this.getSale

            data.discount.find(d => {
                if (
                    d.discount.discountType === 'product' &&
                    this.isSaleProductBonus(d, saleProduct)
                ) {
                    return isBonus = true
                } else if (d.discount.discountType === 'percent') {
                    if (
                        !d.discount.isForAllProducts &&
                        d.discount.discountProducts.find(dp => !dp.isBonus && dp.product.id === saleProduct.product.id) !== undefined
                    ) {
                        percent = d.discount.discountPercent
                        return isPercent = true
                    }
                }
            })

            if (isBonus) {
                return this.$t('sale.discount.discountProduct')
            }

            if (isPercent) {
                return this.showCurrencyByIdWithoutSymbol(
                        data.currency.id,
                        this.calculateReversePercentAmount(saleProduct.price, percent) / saleProduct.amount
                    ) + ' - ' + percent + '% = ' +
                    this.showCurrencyByIdWithoutSymbol(
                        data.currency.id,
                        saleProduct.price / saleProduct.amount
                    )
            }

            return this.showCurrencyByIdWithoutSymbol(data.currency.id, saleProduct.price / saleProduct.amount)
        },
        isSaleProductBonus(discount, saleProduct) {
            return discount.discount.discountProducts.find(
                dp => dp.isBonus &&
                    dp.product.id === saleProduct.product.id &&
                    parseFloat(saleProduct.price) === 0.0
            ) !== undefined
        },
        clickButton() {
            this.$bvModal.show('pay-modal')
            this.payDebt = this.oneSale.totalPrice - this.oneSale.payedAmount
        },
        payDebts() {
            this.$bvModal.hide('pay-modal')
            this.$root.showOverlay = true
            let amount = ((+this.payDebt) + (+this.oneSale.payedAmount)).toString()

            if (parseFloat(amount) === parseFloat(this.oneSale.totalPrice)) {
                this.pushMakePayed({id: this.oneSale.id})
                    .then(() => {
                        this.fetchUpdateSalePayment({
                            id: this.getSale.id,
                            payedAmount: this.getSale.totalPrice,
                            debt: '0.0000'
                        })
                            .then(() => {
                                this.updateSales()
                            })
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.fetchUpdateSalePayment({
                    id: this.oneSale.id,
                    payedAmount: amount,
                    debt: (this.oneSale.totalPrice - (+(this.payDebt) + (+this.oneSale.payedAmount))).toString()
                })
                    .then(() => {
                        this.updateSales()
                    })
            }
        },
        payMoreDebts() {
            this.$bvModal.hide('more-pay-modal')
            this.$root.showOverlay = true

            for (let sale of this.payDebtsSales) {
                this.pushMakePayed({id: sale.id})
                    .then(() => {
                        this.fetchUpdateSalePayment({
                            id: sale.id,
                            payedAmount: sale.totalPrice,
                            debt: '0.0000'
                        })
                    })
            }

            this.updateSales()
            this.$i18nHelper.flash(this.$t('debtor.debtSuccessPaid'), 'success')
            this.payDebtsSales = []
            this.$root.showOverlay = false
        },
        findCustomerName() {
            this.salesTotalPrice = 0.0
            this.salesTotalDebts = 0.0
            this.customers = []
            let customersName = []

            for (let sale of this.payDebtsSales) {
                customersName.push(this.getCustomerName(sale))
                this.salesTotalPrice += this.calculateAmountByBaseCurrency(sale.totalPrice, sale.currency.shortName, this.baseCurrencyShortName)
                this.salesTotalDebts += this.calculateAmountByBaseCurrency(sale.totalPrice - sale.payedAmount, sale.currency.shortName, this.baseCurrencyShortName)
            }

            this.customers = [...new Set(customersName)];
        },
        changeInput() {
            this.isMore = parseInt(this.payDebt) > parseInt(this.sumDebt);
        },
        printA4() {
            this.$i18nHelper.toUrl('sales/transactions/' + this.getSale.id + '/print')
        },
        printCheck() {
            this.$i18nHelper.toUrl('sales/transactions/' + this.getSale.id + '/check-print')
        },
        canceledSale() {
            this.$root.showOverlay = true
            let data = {id: this.oneSale.id}

            this.pushSaleCancel(data)
                .then(() => {
                    this.fetchSale(this.oneSale.id)
                        .then(() => {
                            this.updateSales()
                        })
                    this.$root.showOverlay = false
                })
                .catch(() => {
                    this.$root.showOverlay = false
                })
        },
        showSaleAll(id) {
            this.$root.showOverlay = true

            if (this.saleId === id) {
                this.saleId = 0
            } else {
                this.saleId = id
                this.fetchSale(id)
                    .then(() => {
                        this.saleProductsAndServices = this.getSale.saleProducts.concat( this.getSale.saleServices)
                        this.$root.showOverlay = false
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            }

            this.$root.showOverlay = false
        },
        showCheckbox() {
            this.isCollapsed = !this.isCollapsed

            if (!this.isCollapsed) {
                this.toDeleteSales = []
                this.isSelectedAll = false
            }
        },
        isDebt(sale) {
            return !(sale.totalPrice === sale.payedAmount || sale.isCanceled);
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        setId(product) {
            this.item.id = product.id
            this.item.isCanceled = product.isCanceled
        },
        showModal() {
            if (this.toDeleteSales.length > 0) {
                this.$bvModal.show('delete-sale-modal')
            }
        },
        showModalPayDebts() {
            if (this.payDebtsSales.length > 0) {
                this.findCustomerName()
                this.$bvModal.show('more-pay-modal')
            }
        },
        async deleteSalesAction() {
            this.toDeleteSales.forEach(sale => {
                console.log(sale)
                this.deleteSale(sale)
            })
        },
        deleteSales() {
            this.$root.showOverlay = true

            this.deleteSalesAction()
                .then(() => {
                    this.toDeleteSales = []
                    this.$bvModal.hide('delete-sale-modal')
                    this.isCheckedAll = false
                })
                .finally(() => {
                    setTimeout(this.updateSales, 1000)
                })
        },
        updateSales() {
            this.fetchSales(this.search.page)

            this.$root.showOverlay = false
        },
        cancelDelete() {
            this.$bvModal.hide('delete-sale-modal')
            this.toDeleteSales = []
            this.isCheckedAll = false
        },
        cancel() {
            this.$root.showOverlay = true

            if (!this.item.isCanceled) {
                this.pushSaleCancel({id: this.item.id})
                    .then(() => {
                        this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
                        this.$i18nHelper.toUrl('sales/edit/' + this.item.id);
                    })
            } else {
                this.$i18nHelper.toUrl('sales/edit/' + this.item.id);
            }
        },
        searchSalesInfo() {
            let url = ''
            url += this.search.personGivenName ? 'personGivenName=' + this.search.personGivenName + '&' : ''
            url += this.search.personFamilyName ? 'personFamilyName=' + this.search.personFamilyName + '&' : ''
            url += this.search.personAdditionalName ? 'personAdditionalName=' + this.search.personAdditionalName + '&' : ''
            url += this.search.companyName ? 'companyName=' + this.search.companyName + '&' : ''
            url += this.search.isPayed !== null ? 'isPayed=' + this.search.isPayed + '&' : ''
            url += this.search.after ? 'after=' + this.search.after + '&' : ''
            url += this.search.before ? 'before' + this.search.before + '&' : ''
            url += this.search.sumMin ? 'sumMin' + this.search.sumMin + '&' : ''
            url += this.search.sumMax ? 'sumMax=' + this.search.sumMax + '&' : ''
            url += this.search.page !== 1 ? 'page=' + this.search.page + '&' : ''

            if (this.$route.fullPath + '&' !== this.$i18nHelper.getUrl('sales/transactions?' + url)) {
                this.$i18nHelper.toUrl('sales/transactions?' + url)
            }
        },
        resetSaleSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSalesInfo()
        },
        isBgColorWarning(item) {
            return this.hasNotPayed(item)
        },
        isBgColorDanger(item) {
            return this.hasNotPayedCanceled(item)
        },
        totalPrice(item) {
            return this.showCurrencyById(item.currency.id, item.totalPrice)
        },
        getCustomerName(item) {
            return item.customer.isCompany ?
                item.customer.customerCompany.name :
                item.customer.person.givenName + ' ' + item.customer.person.familyName
        },
        getEmployeeName(item) {
            return item.employee.givenName
        },
        hasNotPayed(item) {
            return item.transaction === null
        },
        hasNotPayedCanceled(item) {
            return item.isCanceled === true
        },
        hasPayedText(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? this.$t('sale.transaction.canceled') : this.$t('payed')
            }

            return this.hasNotPayed(item) ? this.$t('statistics.categories.debt') : this.$t('payed')
        },
        howBgColor(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? '#ead6ef' : '#FFF'
            }

            return this.hasNotPayed(item) ? '#ffeeba' : '#FFF'
        },
        createdAt(item) {
            return this.dateTimeFormat(item.createdAt, true)
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.isSelectedAll = false
                this.isCheckedAll = false
                this.toDeleteSales = []
            }
        },
        'prevRoute.name'() {
            if (this.prevRoute.name === 'sales/newSale') {
                this.showSaleAll(this.getNewSaleId)
                this.oneSale = this.getSales[this.getNewSaleId]
            }
        },
        toDeleteSales() {
            if (this.toDeleteSales.length > 0) {
                for (let sale of this.sales) {
                    if (sale.totalPrice !== sale.payedAmount && !sale.isCanceled) {
                        sale.isSelected = false
                    }
                }
            } else {
                for (let sale of this.sales) {
                    sale.isSelected = true
                }
            }
        },
        payDebtsSales() {
            if (this.payDebtsSales.length > 0) {
                for (let sale of this.sales) {
                    if (sale.totalPrice === sale.payedAmount || sale.isCanceled) {
                        sale.isSelected = false
                    }
                }
            } else {
                for (let sale of this.sales) {
                    sale.isSelected = true
                }
            }
        },
        getSaleServices() {
            this.sales = [];

            for (let sale of this.getSaleServices) {
                sale.isSelected = true;
                this.sales.push(sale)
            }
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    beforeMount() {
        if (Object.keys(this.$route.query).length > 0) {
            let keys = Object.keys(this.$route.query)

            keys.map(key => {
                this.search[key] = this.$route.query[key]
            })

            this.isCollapsed = true
            this.$root.showOverlay = true
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    mounted() {
        this.fetchTodaySaleServiceTotalAmount()
            .then(() => {
                this.purchaseCurrency = this.getCurrency(this.getTodaySaleServiceTotalAmount.currency.id)
                this.selectedCurrencyShortName = this.purchaseCurrency.shortName
            })

    },
}
</script>
<style scoped>
.danger {
    background-color: #bd2130;
    border-color: #bd2130;
    color: white;
}

.danger:hover {
    background-color: red;
    border-color: red;
}

.btn-secondary {
    background-color: #ffffff !important;
    border: none;
    padding: 0;
}

.select-all {
    font-size: 16px;
    margin-top: 5px;
}

.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

.col-1, .col-11 {
    padding: 0 !important;
}

.clear {
    clear: both;
}

@media only screen and (max-width: 845px) {
    ::placeholder {
        font-size: 15px;
    }
}

@media only screen and (max-width: 370px) {
    .date {
        font-size: 14px;
    }
}

.indicator-title {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}

.indicator-total {
    font-size: 18px;
    font-weight: 700;
    color: #8300C5;
}

.indicator {
    border-right: #444444 solid 1px;
    background-color: #F0EEF9;
    padding: 10px 0 10px 20px;
    margin: 1px 0;
}

.padding {
    padding-left: 0.75rem;
    padding-bottom: 0.75rem;
}

button {
    width: 100px;
}
</style>
